<template>
    <div>
        <p v-if="error" class="text-danger">{{errorMsg}}</p>
        
        <!-- <div v-if="validErrors.length" class="text-danger">
            <p v-for="err in validErrors" :key="err">{{err}}</p>
        </div> -->

        <!-- replace later with hot-edit-input components -->
        <b-overlay :show="loading">
        <div class="row spl-inline-form">
            <div class="col-6">

                <div v-if="createNew" class="mb-3">
                    <base-vendor-search-select
                        :preselected-vendor="companyData"
                        @input="handleVendorMultiselectInput"
                        required
                        existing-vendor-badge="EXISTING"
                        :edit-mode="localEditMode"
                        ref="newVendorSearchSelect"
                    ></base-vendor-search-select>
                    <!-- Need to add a handler on here that takes @input and sees if vendor is new or existing, handle accordingly for rest of form -->
                    <p 
                        v-if="vendorExists"
                        class="mb-0 text-danger"
                    >
                        Company already exists.  If you want to update their information, please find them in your vendor database.
                    </p>
                </div>

                <hot-edit-input
                    v-if="!createNew"
                    label="Company Name"
                    v-model="companyData.name"
                    :edit-mode="localEditMode"
                    required
                    :loading="loading"
                    no-edit-class="font-weight-bold"
                    :disabled="createNew && vendorExists"
                    ref="name"
                    class="mb-3"
                ></hot-edit-input>

                <hot-edit-input
                    label="Full Legal Name"
                    v-model="companyData.full_legal_name"
                    :edit-mode="localEditMode"
                    :loading="loading"
                    :disabled="createNew && vendorExists"
                    ref="full_legal_name"
                    class="mb-3"
                ></hot-edit-input>
            
            </div>
            <div class="col-6">

                <hot-edit-input
                    label="Website"
                    v-model="companyData.website"
                    :edit-mode="localEditMode"
                    type="url"
                    :loading="loading"
                    :disabled="createNew && vendorExists"
                    ref="website"
                    class="mb-3"
                ></hot-edit-input>

                <!-- HIDING THIS Aug 23, 2023 - always add as saved vendor for now -->
                <!-- <hot-edit-switch
                    label="Saved Vendor?"
                    v-model="companyData.is_saved"
                    :edit-mode="localEditMode"
                    :loading="loading"
                    :disabled="createNew && vendorExists"
                    ref="is_saved"
                    class="mb-3"
                ></hot-edit-switch> -->
            </div>

            <div v-if="!allRefsValid" class="py-3 px-4">
                <h6 class="text-danger">Please fix these errors:</h6>
                <p 
                    v-for="message in refsInvalidList" 
                    :key="message" 
                    class="text-danger mb-1 small"
                >
                    {{ message }}
                </p>
            </div>

        </div>
        </b-overlay>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import { 
    HotEditInput, 
    //HotEditSelect, 
    //HotEditTextarea, 
    //HotEditSwitch,
    //HotEditMoney,
    //HotEditDatepicker
} from '../js/custom-form-components';
import BaseVendorSearchSelect from './BaseVendorSearchSelect';

import intersection from 'lodash/intersection';
import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

export default {
    name: 'CompanyDetailForm',
    components: {
        HotEditInput,
        //HotEditSelect,
        //HotEditTextarea,
        //HotEditSwitch,
        //HotEditMoney,
        //HotEditDatepicker,
        BaseVendorSearchSelect,
    },
    props: {
        companyId: {
            type: [Number, String],
            required: false,  // because we also use this to create new
        },
        editMode: {  
            // set to TRUE if/when you want to force to edit mode on mount, managed locally through localEditMode 
            // ideally you should call methods enterEditMode() and cancelEditMode() from parent
            type: Boolean,
            default: false,
        },
        createNew: {  // set this to true if using this to create new, not edit existing
            // if this is true, then pk prop and editMode will be IGNORED
            type: Boolean,
            default: false,
        },
        newData: {  // if you want to FORCE any field values for CREATE NEW objects (not update existing), pass it in here
            // fields must be in same format/names as used in API
            type: Object,
            required: false,
        },
        noRefreshOnUpdate: {  // if you set this (to true) then it will not re-fetch updated object after update...
            // you SHOULD set this to true if you're embedding this in a modal or something else that will close the form after update
            type: Boolean,
            default: false,
        },
        addSuccessUrlField: {  // HOLD... maybe implement on parent component -  where to go after successful ADD NEW.  should be name of a field the API returns, must be URL field.  if you don't want to redirect after add, set to empty string '' 
            type: String,
            default: '',
        },
        fieldsToShow: {  // array of field names to SHOW, also limits which ones are used in update/save
            type: Array,
            required: false,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error while getting vendor information.',
            error: false,
            loading: false, 
            localEditMode: this.editMode,  // localEditMode controls things, but this allows parent to force edit mode on create/mount
            dataBeforeEdits: {},  // save here before doing edits
            allCategories: [],  // used if you have options/select things
            companyData: {
                // this gets copied from blankCompanyData in mounted hook
            },
            vendorSearchSelect: null,
            blankCompanyData: {
                name: '',  // name gets set directly by hot-edit-input in update situations, or via BaseVendorSearchSelect (and @input handler method) for new creates (so user can see if vendor is already in DB)
                // address: '',  // removed since we added a proper address thing
                full_legal_name: '',
                website: '',
                is_saved: true,
            },
            vendorExists: false,  // set this to TRUE if BaseVendorSearchSelect returned an existing vendor, then disable all inputs
            /*
            refsToValidate: [
                'newVendorSearchSelect',
                'name',
                'full_legal_name',
                'address',
                'website',
                'is_saved',
            ],  // function validateRefs() will go through all these and validate, triggered by watcher anytime companyData is updated
            refsValid: false,  // this gets set in validateRefs()
            validErrors: [],  // validation errors will go here
            */
            // new validation stuff below...
            allRefsValid: true,  // set true initially... then false if any invalid found when checking, this is used as flag to show refsInvalid
            refsInvalidList: [],  // set this in checkRefsValid()
        }
    },
    computed: {
        objectForUpdate: function() {
            // the vendor object we'll send to API for update -- based on fieldsToShow, if implemented
            let allFieldsOnObject = Object.keys(this.companyData);
            let fieldsToReturn = [...allFieldsOnObject];  // start with this, then take some out if needed
            if (this.fieldsToShow && this.fieldsToShow.length) {  // if we have something in fieldsToShow, then use it to limit things
                fieldsToReturn = intersection(this.fieldsToShow, allFieldsOnObject);
            }
            return pick(this.companyData, fieldsToReturn);
        },
    },
    created: function() {
        this.companyData = merge({}, this.blankCompanyData);
        if (this.createNew) {
            if (!isEmpty(this.newData)) {  // if you 'hard-coded' any newData, merge it in here... have to do Object.assign() or lodash merge() with multiple objects so it is reactive in Vue
                this.companyData = merge({}, this.companyData, this.newData);
            }
            this.enterEditMode();
            //this.getAllCategories();  // haven't implemented yet... it is specific to each field
        } else {
            this.getItemData();
            //this.getAllCategories();  // haven't implemented yet... specific to each field
        }
    },
    methods: {
        // public method:
        /* checkValidity: function() {
            // does all validation checking, returns T/F, and also triggers emit of 'is-valid' and showing error messages
            // call this from parent when you first click submit button or something
            // reset error list first, then call new validation
            this.validErrors = [];
            return this.validateRefs() && this.validateOverall();
        }, */
        // internal methods:
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            if (Array.isArray(message)) {
                this.errorMsg = message.join(', ');
            } else {
                this.errorMsg = message;
            }
            this.error = true;
        },
        objectToArray: function(content) {
            // used to take returned error objects and output them to array of strings
            let outputArray = [];
            if (Object.keys(content).length) {  // check if content has keys (is an object, really)
                for (const [key, value] of Object.entries(content)) {
                    outputArray.push(`${key}: ${value}`);
                }
            } else if (Array.isArray(content)) {
                outputArray = [...content];
            } else {
                outputArray = [content];
            }
            return outputArray;
        },
        /*  these are the OLD validation methods -- replaced with others
        validateOverall: function() {
            // do any form-level validation checking here
            // return true if all OK, false if problem, and add errors to error list
            if (!this.companyData || !this.companyData.name) {
                this.validErrors.push('At least a company name is required.');
                return false;
            }
            return true;
        },
        validateRefs: function() {
            // call this from watcher that triggers when data to save changes
            let isValid = true;  // set to false if we find any invalid
            this.refsToValidate.forEach(ref => {
                if (ref in this.$refs) {
                    let fullRef = this.$refs[ref];
                    let thisRefValid = fullRef.checkValidity();
                    if (!thisRefValid) {
                        isValid = false;
                        this.validErrors.push(fullRef.checkInvalidMessage());
                    }
                }
            });
            this.refsValid = isValid;
            this.$emit('is-valid', isValid);   // emit validation status to parent
            return isValid;
        }, */
        getItemData: function() {
            this.loading = true;
            suppliosApi.vendorStandard.retrieve(this.companyId)
            .then(response => {
                const respData = response.data;
                this.companyData = merge({}, this.companyData, respData);
                this.$emit('loaded', cloneDeep(this.companyData));
            })
            .catch(error => this.handleError(error, 'Error while getting data'))
            .finally(() => {
                this.loading = false;
                //this.localEditMode = false;
            })
        },
        resetRefsValid: function() {
            // resets all refs you checked to default validation state so things aren't always in red outline if validation problems
            let allRefs = Object.values(this.$refs);
            allRefs.forEach(ref => {
                if (ref && Object.keys(ref).includes('resetValidity')) {  // have to check if refs are actually present and if they have resetValidity method
                    ref.resetValidity();  // do the reset
                }
            });
        },
        checkRefsValid: function() {
            let allRefs = Object.values(this.$refs);  // this.$refs is an object, Object.values() makes an array of actual refs
            let refsInvalidList = [];  // we'll make this below... a list of errors from checking refs
            let allRefsValid = true;  // set it to true here, then set to false if you find any invalid in loop below
            allRefs.forEach(ref => {
                if (ref) {  // have to check if refs are actually present
                    let refKeys = Object.keys(ref);
                    if (refKeys.includes('checkValidity')) {
                        let isRefValid = ref.checkValidity();
                        if (isRefValid === false) {  // need to specifically check if 'false' -- because some hot-edit-inputs return 'null' if they aren't in edit mode, we'll ignore those
                            refsInvalidList.push(ref.checkInvalidMessage());
                            allRefsValid = false;
                        }
                    }
                }
            });
            this.refsInvalidList = refsInvalidList;
            this.allRefsValid = allRefsValid;
            return allRefsValid;  // returns a Boolean
        },
        updateItemData: function() { // only used when editing existing item (not saving new)
            //let isValid = this.checkValidity();
            //if (!isValid) return;
            if (!this.checkRefsValid()) return Promise.resolve(false);
            this.loading = true;
            const updatePromise = suppliosApi.vendorStandard.partialUpdate(this.companyId, this.objectForUpdate)
            .then(response => {
                this.$emit('update-complete', response.data);
                console.log(response);
                this.$toast.success("Vendor successfully updated");
                /* this.$bvToast.toast('The data was successfully updated', {
                    title: 'Success!',
                    variant: 'success',
                }); */
                if (!this.noRefreshOnUpdate) {  // only refresh data if we are not in a modal (this is a prop)
                    this.getItemData();
                }
                this.exitEditMode();
            })
            .catch(error => {  // if you have error, keep the form open and in edit mode, showing errors, allowing user to correct things
                this.handleError(error, this.objectToArray(error.response.data));  // error will likely be an object with key = field name and value = error message
            })
            .finally(() => {
                this.loading = false;
            });
            return updatePromise;
        },
        saveNewItem: function() {  // only used when saving new item (not editing existing)
            //let isValid = this.checkValidity();
            //if (!isValid) return;
            if (!this.checkRefsValid()) return Promise.resolve(false);
            this.loading = true;
            const savePromise = suppliosApi.vendorStandard.create(this.objectForUpdate)
            .then(response => {
                this.$emit('save-complete', response.data);
                console.log(response);
                this.$toast.success("Vendor successfully saved");
                /* this.$bvToast.toast('The information was successfully saved', {
                    title: 'Success!',
                    variant: 'success',
                }); */
            })
            .catch(error => {  // if you have error, keep the form open and in edit mode, showing errors, allowing user to correct things
                this.handleError(error, this.objectToArray(error.response.data));  // error will likely be an object with key = field name and value = error message
            })
            .finally(() => {
                this.loading = false;
            });
            return savePromise;
        },
        clearErrors: function() {
            // call this at least when exiting editMode because you're resetting values anyways
            this.error = false;
            this.resetRefsValid(); // set all refs to their default validation visible state
            this.allRefsValid = true;
            this.refsInvalidList = [];
        },
        enterEditMode: function() {
            this.dataBeforeEdits = cloneDeep(this.companyData);  // store this so you have it if you edit then cancel
            this.localEditMode = true;
            this.$emit('edit-on');
        },
        cancelEditMode: function() {
            this.companyData = cloneDeep(this.dataBeforeEdits);
            this.localEditMode = false;
            this.clearErrors();
            this.$emit('edit-off');
        },
        exitEditMode: function() { // exit edit mode, but don't reset item data
            this.localEditMode = false;
            this.$emit('edit-off');
        },
        handleVendorMultiselectInput: function(selectedVendorObj) {
            // takes in object passed from BaseVendorSearchSelect & deals with it
            // BaseVendorSearchSelect only shows if createNew is set... so don't have to worry about update situations
            // if isNew... that's good, then we set vendorExists to false and copy 'name' from emitted object to local data object here
            // if NOT isNew (or isNew key isn't there) then vendorExists is true, and don't copy name
            // so all we need this for is making sure we aren't creating duplicate vendors, then getting new vendor NAME only
            if (selectedVendorObj && 'name' in selectedVendorObj) {  // first see if we have an object passed up
                if ('isNew' in selectedVendorObj && selectedVendorObj.isNew) {
                    // handle case where user entered a new vendor name... 
                    this.vendorExists = false;
                    this.companyData.name = selectedVendorObj.name;
                    return;
                } else {
                    // handle case where isNew was not in the passed up object, so we must be dealing with an existing vendor... show warning to user
                    this.vendorExists = true;
                    this.companyData.name = '';  // set to empty so we make sure we don't create another one
                    return;
                }
            } else {  // in case the multiselect component was reset and passed up empty value, we should set vendorExists to false
                // also need to clear the name here
                this.vendorExists = false;
                this.companyData.name = '';  // need to clear any previous input values
                return;
            }
        }
    },
}
</script>

<style>

</style>